import React from 'react';
import {
	useSequencesContext,
	type TabsOptionsType
} from '../../SequencesContext';

export default function StepsContainerNav() {
	const { selectedSequence } = useSequencesContext();

	return (
		<div className="flex h-[88px] flex-shrink-0 border-b border-dm-grey px-6">
			<TabButton tabOption="SEQUENCE">
				{selectedSequence?.name || 'Preview'}
			</TabButton>
			<TabButton tabOption="BUSINESSES">Businesses</TabButton>
		</div>
	);
}

function TabButton({
	children,
	tabOption
}: {
	children: React.ReactNode;
	tabOption: TabsOptionsType;
}) {
	const { activeTab, setActiveTab, selectedSequence } = useSequencesContext();

	const handleClick = () => {
		setActiveTab(tabOption);
	};

	const isSelected = tabOption === activeTab;

	return (
		<button
			type="button"
			disabled={!selectedSequence}
			onClick={handleClick}
			className={`relative w-full text-base font-semibold lg:text-lg ${
				isSelected ? 'border-dm-gold text-dm-gold' : 'text-dm-white'
			}`}
		>
			{children}
			{isSelected && (
				<div className="absolute bottom-0 left-0 right-0 mx-auto w-full rounded-lg border-2 border-dm-gold" />
			)}
		</button>
	);
}
